import React, { Component } from 'react';
import Article from './Article';

class Portfolio extends Component {
  render() {
    return(
      <Article>
        <div id="article-main" className="flex-overflow-item">
          <h2>Here are some things I've made.</h2>
          <hr />
          <div>
            <a className="title-link" href="http://minesweeper-react.s3-website-us-west-2.amazonaws.com/" ><h3>Minesweeper ;)</h3> <i class="fas fa-chevron-circle-right"></i></a>
            <p><span className="portfolio-page-icons">&#9432;</span> A "Minesweeper" game built in React. You play as a sweeper of an abandoned mine, cleaning up garbage.</p>
            <p><span className="portfolio-page-icons">&#10697;</span> Built with React, HTML, CSS, Javascript. Hosted on AWS.</p>
            <p><span className="portfolio-page-icons">&#8886;</span> <a href="https://github.com/weik55/Minesweeper-React"> See code on GitHub</a></p>
          </div>
          <hr />
          <div>
            <a className="title-link" href="http://tciapp-env-1.ijq4apjene.us-west-2.elasticbeanstalk.com/" ><h3>Ruby on Rails Movie Review DB</h3> <i class="fas fa-chevron-circle-right"></i></a>
            <p><span className="portfolio-page-icons">&#9432;</span> A sample movie review CRUD app that allowed users to post reviews and retrieve movie info.</p>
            <p><span className="portfolio-page-icons">&#10697;</span> Built with Ruby on Rails, HTML, CSS, Javascript. Hosted on AWS.</p>
            <p><span className="portfolio-page-icons">&#8886;</span> <a href="https://github.com/weik55/TCIApp"> See code on GitHub</a></p>
          </div>
          <hr />
          <div>
            <h3>16Bit Dragons</h3>
            <p><span className="portfolio-page-icons">&#9432;</span> A side scrolling infinite runner/shooter game with 16-bit graphics.</p>
            <p><span className="portfolio-page-icons">&#10697;</span> Built with C# using Unity. Graphical assets created using Photoshop.</p>
          </div>
          <hr />
          <div>
            <h3>Pallet Town</h3>
            <p><span className="portfolio-page-icons">&#9432;</span> Recreated Pallet Town from Pokemon games</p>
            <p><span className="portfolio-page-icons">&#10697;</span> Built with C# using Unity. Graphical assets from spriter&#8217;s resource.</p>
            <p><span className="portfolio-page-icons">&#8886;</span> <a href="https://github.com/weik55/Pallet-Town-Unity"> See on GitHub</a></p>
          </div>
          <hr />
          <div>
            <h3>Documentation Publishing System</h3>
            <p><span className="portfolio-page-icons">&#9432;</span> An asynchronous web-application made to automate publishing documentation.</p>
            <p><span className="portfolio-page-icons">&#10697;</span> Built with Java with Play Framework and ElasticSearch, along with jQuery and JsTree</p>
          </div>
          <hr />
          <div>
            <h3>Sample Search Engine</h3>
            <p><span className="portfolio-page-icons">&#9432;</span> This is a search engine I built from the ground up for a class to understand search engine architecture.</p>
            <p><span className="portfolio-page-icons">&#10697;</span> Built with C# with Azure, AWS, and MySQL.</p>
            <p><span className="portfolio-page-icons">&#8886;</span> <a href="https://github.com/weik55/Sample-Search-Engine">See on GitHub</a></p>
          </div>
          <hr />
          <div>
            <h3>Global Timelines</h3>
            <p><span className="portfolio-page-icons">&#9432;</span> This is a website that pulls data from Wikipedia that shows timelines in different regions of the world.</p>
            <p><span className="portfolio-page-icons">&#10697;</span> Built with Python and Google App Engine.</p>
            <p><span className="portfolio-page-icons">&#8886;</span> <a href="https://github.com/weik55/Global-Timelines">See on GitHub</a></p>
          </div>
          <hr />
          <div>
            <h3>Fluffy Muffin</h3>
            <p><span className="portfolio-page-icons">&#9432;</span> Fluffy muffin was a webzine that I built for friends that allowed them to publish comics and articles.</p>
            <p><span className="portfolio-page-icons">&#10697;</span> Built in PHP, HTML, CSS, and Javascript.</p>
          </div>
        </div>
      </Article>
    );
  }
}

export default Portfolio;


// WEBPACK FOOTER //
// ./src/Portfolio.js